import React from "react"
import { createGlobalStyle, ThemeProvider } from "styled-components"
import { Normalize } from "styled-normalize"

import AppContent from "./components/AppContent"
import ErrorBoundary from "./components/ErrorBoundary"
import { theme } from "./theme"

const GlobalStyle = createGlobalStyle`
  html {
    font-family: system-ui, sans-serif;
  }
`

const App = () => (
  <ErrorBoundary>
    <Normalize />
    <GlobalStyle />
    <ThemeProvider theme={theme}>
      <AppContent />
    </ThemeProvider>
  </ErrorBoundary>
)

export default App
